import UIStore from "@Rocket-Innovation/components/store/useUIStore";
import { PATH_EVENT_ACTIVITY } from "@configs";
import { IGetEvent } from "@interfaces";
import liff from "@line/liff";
import { useNotify } from "@utils";
import { Col, Divider, Row, Skeleton, Tabs } from "antd";
import dayjs from "dayjs";
// import JIMP from "jimp"; // Remove this line, use dynamic import below
import jsQR from "jsqr";
import React, { useEffect, useRef, useState } from "react";
import { QrReader } from "react-qr-reader";
import { useHistory, useParams } from "react-router";
import { eventActivityAPI } from "src/API/eventActivity";
import { IGetWebsaleTopSpenderExample } from "src/Interfaces/topCharoen";
import styled from "styled-components";
import { KeyIcon } from "../icon/EventActivity/KeyIcon";
import { ScanIcon } from "../icon/EventActivity/Scan";
import { LineLeftIcon } from "../icon/EventActivity/lineLeft";
import { LineRightIcon } from "../icon/EventActivity/lineRight";
import { IconPoint } from "../icon/IconPoint";
import { BackIcon } from "../icon/TopSpender/BackIcon";
import badgeIcon from "../icon/TopSpender/BadgesRanking.png";

const { TabPane } = Tabs;
interface IProps {
    userInfo: any;
    loggedInUser?: IGetWebsaleTopSpenderExample;
}

export const ComponentEventDetails = (props: IProps) => {
    const qrRef = useRef();
    const { success, error, warning } = useNotify();
    const { userInfo, loggedInUser } = props;
    const history = useHistory();
    const { id } = useParams<{ id: string }>();
    const [eventActivity, setEventActivity] = useState<IGetEvent>();
    const [tab, setTab] = useState<string>("1");
    const [isLine, setIsLine] = useState<boolean>(false);
    const [onScan, setOnScan] = useState<boolean>(false);
    const [ownRank, setOwnRank] = useState<any[]>([]);
    const [ownDetails, setOwnDetails] = useState<any[]>([]);

    const initialContent =
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.";

    const [showAll, setShowAll] = useState(false);
    const lastCharacterIndex = 100;
    const displayContent = showAll ? initialContent : initialContent.substring(0, 100); // เปลี่ยนตัวเลขตามที่คุณต้องการ

    const checkScanner = async () => {
        await null;
        let readScanner = sessionStorage.getItem("READ_SCANNER");
        if (readScanner) {
            onScanQrCode(readScanner)
                .then(() => {
                    sessionStorage.removeItem("READ_SCANNER");
                    // liff.closeWindow();
                })
                .catch(() => {
                    sessionStorage.removeItem("READ_SCANNER");
                    // liff.closeWindow();
                });
        }
    };
    useEffect(() => {
        checkScanner();
    }, []);
    const handleReadMoreClick = () => {
        setShowAll(!showAll);
    };
    const lastCharacter = initialContent.charAt(lastCharacterIndex);
    const indexOfLastCharacter = displayContent.lastIndexOf(lastCharacter);

    const getDetails = async () => {
        try {
            const get = await eventActivityAPI.getEvent(id);
            console.log("getDetails =>", get.data);
            if (get.data) {
                setEventActivity(get.data);
                getOwnDetail();
            }
        } catch (err: any) {
            error(err.message);
        }
    };

    const getOwnDetail = async () => {
        try {
            const get = await eventActivityAPI.getEventRank(`${id}`);
            console.log("getOwnRank =>", get.data);
            if (get.data) {
                setOwnRank(get.data?.docs);
            }
            const getOwn = await eventActivityAPI.getEventOwn(`${id}/${userInfo?.contact?.userId}`);
            if (getOwn.data) {
                setOwnDetails(getOwn.data);
            }
            console.log("getOwnDetail =>", getOwn.data);
        } catch (err: any) {
            error(err.message);
        }
    };

    function callback(items: any) {
        setTab(items);
    }

    const checkBrowser = async () => {
        await null;
        const userAgent = navigator.userAgent;
        let lowerText: string = userAgent.toLowerCase();
        console.log("userAgent =>", lowerText);
        if (
            lowerText.includes("line")
            // && lowerText.includes('android')
        ) {
            setIsLine(true);
        }
    };

    // const openLiff = async () => {
    //     const liffUrl = await liff.permanentLink.createUrlBy(
    //         LIFF_SCAN_QRCODE + window.location.pathname
    //     );
    //     // alert(liffUrl);
    //     window.location.href = liffUrl;
    // };
    const clickImgQr = () => {
        if (qrRef.current) {
            //@ts-ignore
            qrRef.current.click();
        }
    };

    const changeQr = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target?.files?.[0];
        if (file) {
            let imgUrl = URL.createObjectURL(file);
            findQRCodeInImage(imgUrl)
                .then((code) => {
                    if (code) {
                        console.log("QR code data:", code);
                        onScanQrCode(code);
                    } else {
                        warning("No QR code found in the image.");
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        }
    };
    function findQRCodeInImage(imageUrl: string): Promise<string | null> {
        return new Promise((resolve, reject) => {
            const img = new window.Image();
            img.crossOrigin = "Anonymous";
            img.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext("2d");
                if (!ctx) return resolve(null);
                ctx.drawImage(img, 0, 0, img.width, img.height);
                const imageData = ctx.getImageData(0, 0, img.width, img.height);
                const code = jsQR(imageData.data, img.width, img.height);
                if (code) resolve(code.data);
                else resolve(null);
            };
            img.onerror = reject;
            img.src = imageUrl;
        });
    }

    const onScanQrCode = async (code: string) => {
        if (code) {
            try {
                UIStore.setState({ isLoading: true });
                const updateQr = await eventActivityAPI.scanQrEvent({
                    eventActivityId: id,
                    qrImageId: code,
                    contactId: userInfo?.contact?._id,
                    createdAt: dayjs().toISOString(),
                });
                console.log("updateQr =>", updateQr.data);
                if (updateQr.data) {
                    success("success");
                    setOnScan(false);
                    getOwnDetail();
                }
            } catch (err: any) {
                err.response?.data?.message
                    ? error(err.response?.data?.message)
                    : error(err.message);
            } finally {
                //delay for loading
                await new Promise((resolve) => setTimeout(resolve, 500));
                UIStore.setState({ isLoading: false });
                setOnScan(false);
            }
        }
    };

    const handleLineScan = async () => {
        try {
            const result = await liff.scanCodeV2();
            console.log("Scanned code:", result);
            if (result?.value) {
                onScanQrCode(result?.value);
            }

            // alert(result.value);
        } catch (err) {
            console.error(err);
            alert(err);
        }
    };

    useEffect(() => {
        // getList();
        getDetails();
        checkBrowser();
        // console.log("pathname =>", window.location.pathname);
    }, []);

    const mockData = {
        eventActivity: {
            eventActivityType: {
                typeName: "ranking",
            },
            themeColor: "#FF5733",
        },
        ownRanks: [
            {
                rank: 0,
                firstName: "John",
                lastName: "Doe",
                phoneNumber: "0123456789",
                total: 12345,
            },
            {
                rank: 1,
                firstName: "Jane",
                lastName: "Smith",
                phoneNumber: "0987654321",
                total: 67890,
            },
        ],
        tab: "2",
        badgeIcon: "/path/to/badgeIcon.png",
    };

    return eventActivity ? (
        <StyledContainer color={eventActivity?.themeColor ? eventActivity?.themeColor : "#336C51"}>
            <input
                //@ts-ignore
                ref={qrRef}
                type="file"
                hidden
                id="uploadQr"
                onChange={changeQr}
                accept="image/png, image/jpeg, image/jpg"
            />
            {!onScan ? (
                <div className="container">
                    <div
                        className="backIcon"
                        onClick={() => history.push(PATH_EVENT_ACTIVITY + "/home")}
                    >
                        <BackIcon
                            color={
                                eventActivity?.themeColor ? eventActivity?.themeColor : "#336C51"
                            }
                        />
                    </div>
                    <div className="topImage">
                        <img
                            src={eventActivity.coverImage[0] ? eventActivity.coverImage[0] : ""}
                            alt="test"
                            className="topHeaderImage"
                        />
                    </div>
                    <div className="content">
                        <Tabs
                            defaultActiveKey="1"
                            activeKey={tab}
                            onChange={callback}
                            tabBarStyle={{
                                backgroundColor: "transparent",
                            }}
                        >
                            <TabPane
                                tab={
                                    <span
                                        style={{
                                            color:
                                                tab === "1" ? eventActivity?.themeColor : "#9B9B9B",
                                        }}
                                    >
                                        Information
                                    </span>
                                }
                                key="1"
                            >
                                <div>
                                    <h1>{eventActivity?.name ? eventActivity?.name : ""}</h1>
                                    <p>
                                        {showAll
                                            ? eventActivity?.detail
                                            : eventActivity?.detail.substring(0, 100)}
                                        <span>
                                            {eventActivity?.detail.length > 100 && (
                                                <button
                                                    onClick={handleReadMoreClick}
                                                    className="readMoreButton"
                                                >
                                                    {showAll ? "Read Less" : "Read More"}
                                                </button>
                                            )}
                                        </span>
                                    </p>
                                    <Divider />
                                    <div className="listColumn">
                                        {eventActivity?.eventActivityType?.typeName !==
                                            "ranking" && <p className="listTitle">Reward</p>}

                                        {eventActivity?.eventActivityType?.itemFromReward &&
                                        eventActivity?.eventActivityType?.typeName !== "ranking" ? (
                                            <Row className={`listItemsReward`} key={1}>
                                                <Col
                                                    span={3}
                                                    style={{
                                                        paddingLeft: 0,
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            position: "relative",
                                                            width: "24px",
                                                        }}
                                                    >
                                                        <img
                                                            src={
                                                                eventActivity?.eventActivityType
                                                                    ?.itemFromRewardDetails
                                                                    ?.imageUrl[0]
                                                                    ? eventActivity
                                                                          ?.eventActivityType
                                                                          ?.itemFromRewardDetails
                                                                          ?.imageUrl[0]
                                                                    : ""
                                                            }
                                                            alt="medal"
                                                            style={{
                                                                width: "42px",
                                                                height: "42px",
                                                                borderRadius: "8px",
                                                            }}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col span={21}>
                                                    <p className="gray">
                                                        <span>
                                                            <KeyIcon />
                                                        </span>
                                                        Unlock per{" "}
                                                        {eventActivity?.goalFromActivity?.qrQty} QR
                                                        Code
                                                    </p>
                                                    <p>Get Reward....</p>
                                                </Col>
                                            </Row>
                                        ) : (
                                            ""
                                        )}
                                        {eventActivity?.eventActivityType?.pointPerQRCode &&
                                        eventActivity?.eventActivityType?.typeName !== "ranking" ? (
                                            <Row className={`listItemsReward`} key={1}>
                                                <Col
                                                    span={3}
                                                    style={{
                                                        paddingLeft: 0,
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            position: "relative",
                                                            width: "24px",
                                                        }}
                                                    >
                                                        <IconPoint />
                                                    </div>
                                                </Col>
                                                <Col span={21}>
                                                    <p className="gray">
                                                        <span>
                                                            <KeyIcon />
                                                        </span>
                                                        Unlock per 1 QR Code
                                                    </p>
                                                    <p>
                                                        Get{" "}
                                                        {eventActivity?.eventActivityType
                                                            ?.pointPerQRCode
                                                            ? eventActivity?.eventActivityType
                                                                  ?.pointPerQRCode
                                                            : " ... "}{" "}
                                                        points
                                                    </p>
                                                </Col>
                                            </Row>
                                        ) : (
                                            ""
                                        )}
                                        {eventActivity?.eventActivityType?.pointComplete &&
                                        eventActivity?.eventActivityType?.typeName !== "ranking" ? (
                                            <Row className={`listItemsReward`} key={2}>
                                                <Col
                                                    span={3}
                                                    style={{
                                                        paddingLeft: 0,
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            position: "relative",
                                                            width: "24px",
                                                        }}
                                                    >
                                                        <IconPoint />
                                                    </div>
                                                </Col>
                                                <Col span={21}>
                                                    <p className="gray">
                                                        <span>
                                                            <KeyIcon />
                                                        </span>
                                                        Unlock Complete QR Code
                                                    </p>
                                                    <p>
                                                        Get{" "}
                                                        {eventActivity?.eventActivityType
                                                            ?.pointComplete
                                                            ? eventActivity?.eventActivityType
                                                                  ?.pointComplete
                                                            : " ... "}{" "}
                                                        points
                                                    </p>
                                                </Col>
                                            </Row>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                </div>
                            </TabPane>
                            {eventActivity?.eventActivityType?.typeName === "ranking" && (
                                <TabPane
                                    tab={
                                        <span
                                            style={{
                                                color:
                                                    tab === "2"
                                                        ? eventActivity?.themeColor
                                                        : "#9B9B9B",
                                            }}
                                        >
                                            Ranking
                                        </span>
                                    }
                                    key="2"
                                >
                                    <div className="listColumn">
                                        <Row>
                                            <Col span={4}>
                                                <table>
                                                    <th>Member</th>
                                                </table>
                                            </Col>
                                            <Col span={14}>
                                                <table>
                                                    <th></th>
                                                </table>
                                            </Col>
                                            <Col span={6}>
                                                <table
                                                    style={{
                                                        marginLeft: "auto",
                                                        textAlign: "right",
                                                    }}
                                                >
                                                    <th>Complete</th>
                                                </table>
                                            </Col>
                                        </Row>
                                        {ownRank.map((item, i) => {
                                            return (
                                                <Row className={`listItemsRow`} key={1}>
                                                    <Col
                                                        span={4}
                                                        style={{
                                                            paddingLeft: 0,
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                position: "relative",
                                                                width: "35px",
                                                            }}
                                                        >
                                                            <img
                                                                src={badgeIcon}
                                                                alt="medal"
                                                                style={{
                                                                    width: "35px",
                                                                }}
                                                            />

                                                            <div
                                                                style={{
                                                                    color: "white",
                                                                    position: "absolute",
                                                                    top: "42%",
                                                                    left: "50%",
                                                                    transform:
                                                                        "translate(-50%, -50%)",
                                                                    fontSize: "10px",
                                                                    fontWeight: "bold",
                                                                }}
                                                            >
                                                                {item.rank + 1}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col span={14}>
                                                        <p>
                                                            {item?.firstName
                                                                ? item?.firstName
                                                                : "" + " " + item?.lastName
                                                                ? item?.lastName
                                                                : "" || "Unknown"}
                                                        </p>
                                                        <p className="gray">
                                                            {item.phoneNumber &&
                                                                "0" +
                                                                    item?.phoneNumber.substring(
                                                                        3,
                                                                        item?.phoneNumber.length - 7
                                                                    ) +
                                                                    "***" +
                                                                    item?.phoneNumber.substring(
                                                                        item?.phoneNumber.length - 4
                                                                    )}
                                                        </p>
                                                    </Col>
                                                    <Col span={6}>
                                                        <p className="blueText">
                                                            {item?.total.toLocaleString()}
                                                        </p>
                                                    </Col>
                                                </Row>
                                            );
                                        })}
                                    </div>
                                </TabPane>
                            )}
                            {eventActivity?.eventActivityType?.typeName !== "ranking" && (
                                <TabPane
                                    tab={
                                        <span
                                            style={{
                                                color:
                                                    tab === "3"
                                                        ? eventActivity?.themeColor
                                                        : "#9B9B9B",
                                            }}
                                        >
                                            My Collect QR Code
                                        </span>
                                    }
                                    key="3"
                                >
                                    <div className="contentCollect">
                                        <br />
                                        <h2>Your QR code collect this event</h2>
                                        <br />
                                        <div className="contentProgress">
                                            <div className="numProgress">
                                                {ownDetails[0]?.total ? ownDetails[0]?.total : 0}/
                                                {eventActivity?.goalFromActivity?.qrQty}{" "}
                                                <span className="textProgress"> QR code</span>
                                            </div>
                                        </div>
                                        <br />
                                        {eventActivity?.eventActivityType?.pointComplete ? (
                                            <div>
                                                <h2>
                                                    1 QR code to{" "}
                                                    <span>
                                                        <IconPoint />
                                                    </span>
                                                    {eventActivity?.eventActivityType
                                                        ?.pointPerQRCode
                                                        ? eventActivity?.eventActivityType
                                                              ?.pointPerQRCode
                                                        : " "}{" "}
                                                    points
                                                </h2>
                                                <br />
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                        <h1>
                                            <span>
                                                <LineLeftIcon />
                                            </span>{" "}
                                            Scan{" "}
                                            {eventActivity?.goalFromActivity?.qrQty -
                                                ownDetails[0]?.total}{" "}
                                            QR Left to{" "}
                                            {eventActivity?.eventActivityType?.pointComplete
                                                ? "get bonus."
                                                : "get Reward"}
                                            .{" "}
                                            <span>
                                                <LineRightIcon />
                                            </span>
                                        </h1>
                                        <br />

                                        {eventActivity?.eventActivityType?.pointComplete ? (
                                            <div className="wrapper-content-point">
                                                <div className="img-contentpoint-top">
                                                    <img
                                                        src="../../images/img-bonus-top.png"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="contentPoint">
                                                    <h1>
                                                        <span>
                                                            <IconPoint />
                                                        </span>{" "}
                                                        {
                                                            eventActivity?.eventActivityType
                                                                ?.pointComplete
                                                        }
                                                    </h1>
                                                    <p>Complete</p>
                                                </div>
                                                <div className="img-contentpoint-bottom">
                                                    <img
                                                        src="../../images/img-bonus-bottom.png"
                                                        alt=""
                                                    />
                                                </div>
                                            </div>
                                        ) : (
                                            <img
                                                src={
                                                    eventActivity?.eventActivityType
                                                        ?.itemFromRewardDetails?.imageUrl[0]
                                                        ? eventActivity?.eventActivityType
                                                              ?.itemFromRewardDetails?.imageUrl[0]
                                                        : ""
                                                }
                                            />
                                        )}
                                    </div>
                                </TabPane>
                            )}
                        </Tabs>
                        {tab === "1" || tab === "3" ? (
                            <div className="bottomContent">
                                <button
                                    onClick={() => {
                                        if (isLine) {
                                            handleLineScan();
                                        } else setOnScan(true);
                                    }}
                                >
                                    <ScanIcon />
                                    Scan collect now!
                                </button>
                            </div>
                        ) : (
                            <div className="bottomContentAndRank">
                                <Row className={`listItemsRow`} key={1}>
                                    <Col
                                        span={4}
                                        style={{
                                            paddingLeft: 0,
                                        }}
                                    >
                                        <div
                                            style={{
                                                position: "relative",
                                                width: "35px",
                                            }}
                                        >
                                            {/* <MedalIcon /> */}
                                            <img
                                                src={badgeIcon}
                                                alt="medal"
                                                style={{
                                                    width: "35px",
                                                }}
                                            />

                                            <div
                                                style={{
                                                    color: "white",
                                                    position: "absolute",
                                                    top: "42%",
                                                    left: "50%",
                                                    transform: "translate(-50%, -50%)",
                                                    fontSize: "10px",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                {ownDetails[0]?.rank}
                                            </div>
                                        </div>
                                    </Col>
                                    <Col span={14}>
                                        <p>
                                            {ownDetails[0]?.firstName
                                                ? ownDetails[0]?.firstName
                                                : "" + " " + ownDetails[0]?.lastName
                                                ? ownDetails[0]?.lastName
                                                : "" || "Unknown"}
                                        </p>
                                        <p className="gray">
                                            {ownDetails[0].phoneNumber &&
                                                "0" +
                                                    ownDetails[0]?.phoneNumber.substring(
                                                        3,
                                                        ownDetails[0]?.phoneNumber.length - 7
                                                    ) +
                                                    "***" +
                                                    ownDetails[0]?.phoneNumber.substring(
                                                        ownDetails[0]?.phoneNumber.length - 4
                                                    )}
                                        </p>
                                    </Col>
                                    <Col span={6}>
                                        <p className="blueText">
                                            {ownDetails[0]?.total.toLocaleString()}
                                        </p>
                                    </Col>
                                </Row>
                                <button
                                    onClick={() => {
                                        if (isLine) {
                                            handleLineScan();
                                        } else setOnScan(true);
                                    }}
                                >
                                    <ScanIcon />
                                    Scan collect now!
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            ) : (
                <div className="qr2">
                    <div className="backIcon" onClick={() => setOnScan(false)}>
                        <BackIcon
                            color={
                                eventActivity?.themeColor ? eventActivity?.themeColor : "#336C51"
                            }
                        />
                    </div>
                    <QrReader
                        onResult={(result: any, error) => {
                            if (result?.text) {
                                console.log("result =>", result);
                                onScanQrCode(result?.text);
                            }
                        }}
                        constraints={{ facingMode: "environment" }}
                        scanDelay={300}
                    />
                    <br />
                    <br />
                    <br />
                    <div
                        style={{
                            width: "100%",
                            textAlign: "center",
                        }}
                    >
                        <button onClick={clickImgQr}>
                            <img src="../images/ic-select-image.png" alt="" />
                            {" Select image"}
                        </button>
                    </div>
                </div>
            )}
        </StyledContainer>
    ) : (
        <Skeleton />
    );
};

const StyledContainer = styled.div<{ color: string }>`
    height: 100dvh;
    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: #ff0000 !important;
        font-weight: 500;
    }
    .ant-tabs-nav-wrap {
        .ant-tabs-ink-bar {
            position: absolute;
            background: #c4a363;
            pointer-events: none;
            width: 20px !important;
            height: 3px;
            bottom: 5px;
            left: 37px;
            border-radius: 4px;
        }
    }
    .ant-tabs-content {
        margin-top: 10px;
    }

    .qr2 {
        padding: 16px 16px 12px 16px;
        width: 100%;
        align-items: center;
        flex-direction: column;
        button {
            padding: 14.5px 24px;
            justify-content: center;
            gap: 4px;
            border-radius: 14px;
            border: 1px solid var(--Hightlight, #f2ca3c);
            background: var(--Primary-1, #336c51);
            box-shadow: 0px 4px 12px 0px rgba(242, 202, 60, 0.32);
            color: var(--Text-6, #fff);
            text-align: center;
            font-size: 13px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            width: 100%;
        }
    }
    .container {
        .backIcon {
            position: absolute;
            top: 20px;
            left: 20px;
            cursor: pointer;
            z-index: 1;
        }
        background: linear-gradient(
                180deg,
                rgba(255, 255, 255, 255) 45%,
                ${(props) => props.color} 100%
            ),
            linear-gradient(
                180deg,
                rgba(195, 155, 108, 0) 0%,
                rgba(195, 155, 108, 0.42) 70.31%,
                #fff 100%
            ),
            #fff;
        // min-height: 100vh;
        .ant-divider {
            background: #e1e1e1;
            width: 90%;
            min-width: 90%;
            margin: auto;
            margin: 22px auto 16px auto;
        }
    }
    .topHeaderImage {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .topImage {
        position: relative;
        min-height: 200px;
        /* padding-bottom: 10px; */
    }
    .whiteGradiant {
        background: linear-gradient(
            to bottom,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.62) 90%,
            #fff 100%
        );
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        z-index: 0;
    }
    .content {
        width: 100%;
        height: 70dvh;
        background-color: rgba(246, 246, 246, 1);
        position: absolute;
        left: 0;
        bottom: 0;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        overflow: hidden;
        padding: 9px 16px 0px 16px;
        .ant-tabs-nav {
            .ant-tabs-tab {
                padding: 0;
                margin: 0px 10px 10px 0px !important;
                width: 95px;
                span {
                    font-size: 16px;
                    font-weight: 600;
                }
            }
            &::before {
                /* border:none; */
                bottom: 6px;
            }
        }
        h1 {
            color: #000;
            font-size: 18px;
            line-height: 21px;
            font-weight: 600;
            margin-bottom: 10px;
        }
        p {
            color: #9b9b9b;
            font-size: 14px;
            line-height: 20px;
            margin-bottom: 16px;
        }
        small {
            color: #525257;
            text-align: center;
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            display: block;
        }
        .listTitle {
            color: ${(p) => p.color};
            font-size: 13px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
        }
        .readMoreButton {
            text-decoration: underline;
            background: none;
            border: none;
            cursor: pointer;
            color: ${(p) => p.color};
            font-size: inherit;
        }
        .listColumn {
            display: flex;
            flex-direction: column;
            gap: 6px;
            position: relative;
            overflow: auto;
            height: 62vh;
            padding-bottom: 20px;
            th {
                color: #9b9b9b;
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: 20px;
            }
            .ant-row {
                padding: 6px 18px;
            }
            .listItemsRow {
                padding: 12px 20px;
                border-radius: 12px;
                background: #fff;
                display: flex;
                place-items: center;
                box-shadow: none;
                p {
                    color: #000;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 20px;
                    text-align: left;
                    margin: 0;
                }
                .gray {
                    color: #9b9b9b;
                    font-size: 12px;
                }
                .blueText {
                    color: ${(p) => p.color};
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: inherit;
                    text-align: right;
                }
                .placeIndex {
                    color: #000;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 20px;
                    padding-left: 8px;
                }
                .textrank {
                    color: #fff;
                    font-size: 8px;
                }
            }
            .listItemsReward {
                padding: 12px 20px;
                border-radius: 12px;
                background: rgba(51, 108, 81, 0.08);
                display: flex;
                place-items: center;
                box-shadow: none;
                p {
                    color: #000;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: 20px;
                    text-align: left;
                    margin: 0;
                }
                .gray {
                    color: #9b9b9b;
                    font-size: 12px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: flex-start;
                    gap: 5px;
                }
                .placeIndex {
                    color: #000;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 20px;
                    padding-left: 8px;
                }
            }
        }
        .bottomContent {
            display: flex;
            padding: 16px 16px 12px 16px;
            flex-direction: column;
            align-items: center;
            gap: 9px;
            align-self: stretch;
            width: 100%;
            height: 10dvh;
            background: linear-gradient(
                    180deg,
                    rgba(196, 163, 99, 0.32) 0%,
                    rgba(196, 163, 99, 0) 92.98%
                ),
                #fff;
            position: absolute;
            left: 0;
            bottom: 0;
            border-top-right-radius: 16px;
            border-top-left-radius: 16px;
            button {
                display: flex;
                padding: 14.5px 24px;
                justify-content: center;
                align-items: center;
                gap: 4px;
                align-self: stretch;
                border-radius: 14px;
                border: 1px solid var(--Hightlight, #f2ca3c);
                background: ${(p) => p.color};
                box-shadow: 0px 4px 12px 0px rgba(242, 202, 60, 0.32);
                color: var(--Text-6, #fff);
                text-align: center;
                font-size: 13px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
            }
        }

        textScan {
            color: var(--Text-6, #fff);
            text-align: center;
            font-size: 13px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
        }
        .bottomContentAndRank {
            display: flex;
            padding: 16px 16px 12px 16px;
            flex-direction: column;
            align-items: center;
            gap: 9px;
            align-self: stretch;
            width: 100%;
            height: 15dvh;
            background: linear-gradient(
                    180deg,
                    rgba(196, 163, 99, 0.32) 0%,
                    rgba(196, 163, 99, 0) 92.98%
                ),
                #fff;
            position: absolute;
            left: 0;
            bottom: 0;
            border-top-right-radius: 16px;
            border-top-left-radius: 16px;
            button {
                display: flex;
                padding: 14.5px 24px;
                justify-content: center;
                align-items: center;
                gap: 4px;
                align-self: stretch;
                border-radius: 14px;
                border: 1px solid var(--Hightlight, #f2ca3c);
                background: var(--Primary-1, #336c51);
                box-shadow: 0px 4px 12px 0px rgba(242, 202, 60, 0.32);
                color: var(--Text-6, #fff);
                text-align: center;
                font-size: 13px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
            }
            .listItemsRow {
                padding: 0px 20px;
                width: 100%;
                display: flex;
                place-items: center;
                box-shadow: none;
                p {
                    color: #000;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 20px;
                    text-align: left;
                    margin: 0;
                }
                .gray {
                    color: #9b9b9b;
                    font-size: 12px;
                }
                .blueText {
                    color: ${(p) => p.color};
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: inherit;
                    text-align: right;
                }
                .placeIndex {
                    color: #000;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 20px;
                    padding-left: 8px;
                }
                .textrank {
                    color: #fff;
                    font-size: 8px;
                }
            }
        }
        .contentCollect {
            align-items: center;
            overflow: auto;
            height: 55dvh;
            h2 {
                color: var(--Text-1, #000);
                text-align: center;
                font-size: 14px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
                margin: 10px 0;
            }
            h1 {
                color: var(--Error, #e53223);
                text-align: center;
                font-size: 16px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
                margin: 10px 0;
                gap: 10px;
                display: flex;
                justify-content: center;
            }
            img {
                width: 100%;
                border-radius: 14px;
            }
            .contentProgress {
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 10px;
                height: 70px;
                width: 100%;
                border-radius: 12px;
                background-repeat: no-repeat;
                background-image: url(../../images/bg-box-reward.png);
                background-size: cover;
                background-position: center;
                .numProgress {
                    color: var(--Text-4, #336c51);
                    text-align: center;
                    font-size: 32px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: normal;
                }
                .textProgress {
                    color: var(--Text-4, #336c51);
                    text-align: center;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: normal;
                }
            }
            .wrapper-content-point {
                position: relative;
                .img-contentpoint-top {
                    position: absolute;
                    top: -25px;
                    z-index: 1;
                    left: calc(50% + 50px);
                    transform: translateX(-50%);
                    img {
                        width: 65px;
                    }
                }
                .img-contentpoint-bottom {
                    position: absolute;
                    bottom: -30px;
                    left: 50%;
                    z-index: 1;
                    transform: translateX(-50%);
                    img {
                        width: 260px;
                    }
                }
                .contentPoint {
                    position: relative;
                    display: flex;
                    width: 100%;
                    height: 115px;
                    padding: 10px 0px;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    gap: 1px;
                    flex-shrink: 0;
                    border-radius: 12px;
                    border: 1px solid rgba(242, 202, 60, 0.54);
                    // background: linear-gradient(0deg, rgba(242, 202, 60, 0.20) 0%, rgba(242, 202, 60, 0.20) 100%), #FFF;
                    box-shadow: 0px 4px 20px 0px rgba(242, 202, 60, 0.2);
                    background-image: url(../../images/bg-bonus.png);
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: cover;
                    h1 {
                        color: var(--Text-1, #000);
                        text-align: center;
                        font-size: 32px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: normal;
                        margin: 0;
                    }
                    p {
                        color: var(--Text-1, #000);
                        text-align: center;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: normal;
                    }
                }
            }
        }
    }
`;
